export enum AfterAction {
    Print = 1,
    Email = 2,
    AddDonor = 3
}